import React from 'react';

import Contact from './Contact'

import styles from './end.module.css';

const Quote = ({resumeLink}) => {
  return (
    <div className={styles.wrapper}>
      <div className="resumeButton"><a href={resumeLink} download>View Resume</a></div>
      <Contact type="bottom"/>
    </div>
  )
}

export default Quote;